import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hr-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hr-features.html',
  styleUrls: ['./hr-features.css'],
})
export class HrFeaturesComponent {}
